module.exports = __webpack_public_path__ + "img/gmdl_icon2.708d2310.png";